var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 102,
    viewBox: "0 0 120 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2969 30.1805V21.7805C41.2969 13.3805 47.9969 6.48047 56.4969 6.48047C64.7969 6.48047 71.6969 13.2805 71.6969 21.7805V30.1805",
    stroke: "#C7D2DD",
    strokeWidth: 1.8941,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2969 92.582C93.6969 92.382 93.7969 92.182 94.1969 92.082",
    stroke: "#FF78B7",
    strokeWidth: 0.6123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 100.582H118.097",
    stroke: "#B1B9CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 100.582H5.4",
    stroke: "#B1B9CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.903 14.2812H15.7031V99.6812H100.903V14.2812Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.098 14.2812H39.3984V99.6812H100.998V14.2812H101.098Z",
    fill: "#E6ECF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5031 14.2812H15.7031V99.6812H27.5031V14.2812Z",
    fill: "url(#paint0_linear_2463_300)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4031 99.682H15.7031V99.482L27.7031 87.582L39.4031 99.682Z",
    fill: "#E6ECF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3031 33.282C56.0031 33.282 57.4031 31.882 57.4031 30.182C57.4031 28.482 56.0031 27.082 54.3031 27.082C52.6031 27.082 51.2031 28.482 51.2031 30.182C51.2031 31.882 52.6031 33.282 54.3031 33.282Z",
    fill: "#C7D2DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7016 33.282C86.4016 33.282 87.8016 31.882 87.8016 30.182C87.8016 28.482 86.4016 27.082 84.7016 27.082C83.0016 27.082 81.6016 28.482 81.6016 30.182C81.7016 31.882 83.0016 33.282 84.7016 33.282Z",
    fill: "#C7D2DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2969 30.1805V21.7805C54.2969 13.3805 60.9969 6.48047 69.4969 6.48047C77.7969 6.48047 84.6969 13.2805 84.6969 21.7805V30.1805",
    stroke: "#C7D2DD",
    strokeWidth: 1.8941,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3907 3.04232C96.5502 1.65802 99.0973 0.882812 101.811 0.882812C109.23 0.882812 115.266 6.86298 115.266 14.2828C115.266 21.7027 109.23 27.6828 101.811 27.6828C94.3907 27.6828 88.3552 21.7027 88.3552 14.2828C88.2444 9.57621 90.6808 5.47868 94.3907 3.04232Z",
    fill: "url(#paint1_linear_2463_300)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.813 20.2812C99.1098 20.2812 96.8125 17.8543 96.8125 14.2138C96.8125 10.5734 99.1098 8.28125 101.813 8.28125C104.515 8.28125 106.813 10.5734 106.813 14.2138C106.813 17.8543 104.515 20.2812 101.813 20.2812ZM101.813 17.4498C102.758 17.4498 103.704 16.506 103.704 14.2138C103.84 12.0565 102.758 10.9779 101.813 10.9779C100.867 10.9779 99.9206 12.0565 99.9206 14.2138C99.9206 16.506 100.867 17.4498 101.813 17.4498Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8731 57.5798C56.438 57.5798 53.5525 55.382 52.4533 52.2227C52.1785 51.5359 52.5907 50.8491 53.2777 50.5743C53.9647 50.2996 54.6517 50.7117 54.9265 51.3985C55.6136 53.4589 57.6746 54.9699 59.8731 54.9699C62.0716 54.9699 64.1327 53.5963 64.8197 51.3985C65.0945 50.7117 65.7815 50.2996 66.4685 50.5743C67.1556 50.8491 67.5678 51.5359 67.293 52.2227C66.1937 55.5194 63.3082 57.5798 59.8731 57.5798Z",
    fill: "#ADB6C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6231 57.5798C77.188 57.5798 74.3025 55.382 73.2033 52.2227C72.9285 51.5359 73.3407 50.8491 74.0277 50.5743C74.7147 50.2996 75.4017 50.7117 75.6765 51.3985C76.3636 53.4589 78.4246 54.9699 80.6231 54.9699C82.8216 54.9699 84.8827 53.5963 85.5697 51.3985C85.8445 50.7117 86.5315 50.2996 87.2185 50.5743C87.9056 50.8491 88.3178 51.5359 88.043 52.2227C86.9437 55.5194 84.0582 57.5798 80.6231 57.5798Z",
    fill: "#ADB6C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3166 74.4007C72.0619 74.4007 73.4769 72.9862 73.4769 71.2414C73.4769 69.4965 72.0619 68.082 70.3166 68.082C68.5712 68.082 67.1562 69.4965 67.1562 71.2414C67.1562 72.9862 68.5712 74.4007 70.3166 74.4007Z",
    fill: "#ADB6C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7592 4.64967V0H30.7294V4.64967L18.4674 19.4441H30.9408V24.0937H12.125V19.4441L24.387 4.64967H12.7592V4.64967Z",
    fill: "url(#paint2_linear_2463_300)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5634 39.5214V36.5625H39.1912V39.5214L31.3689 49.0321H39.4026V51.991H27.1406V49.0321L34.9629 39.5214H27.5634Z",
    fill: "url(#paint3_linear_2463_300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2463_300",
    x1: 21.577,
    y1: 16.554,
    x2: 21.577,
    y2: 98.4523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2463_300",
    x1: 101.811,
    y1: 1.81381,
    x2: 101.811,
    y2: 16.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2463_300",
    x1: 21.5344,
    y1: 0.836988,
    x2: 21.5344,
    y2: 14.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2463_300",
    x1: 33.2726,
    y1: 37.0985,
    x2: 33.2726,
    y2: 45.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.16668c4e238a5c976e6eeba12bff873f.svg";
export { ForwardRef as ReactComponent };